
import { sendLogClick } from './index'

export default {
  // 登录按钮
  loginBtnLog(data) {
    sendLogClick('smallfox-teacher_33', {
      ...data
    })
  }
}